import React, { useEffect, useState } from 'react'
import EventContext from './EventContext';
import axios from 'axios';

const EventProvider = ({ children }) => {
    const [createEvent, setCreateEvent] = useState(false);
    const [editEvent, setEditEvent] = useState(false);
    const [currEvent, setCurrEvent] = useState();
    const [events, setEvents] = useState([]);
    const [expiredEvents,setExpiredEvents] = useState();
    const [activeEvents,setActiveEvents] = useState();
    const [orgStats,setOrgStats] = useState();
  
    const handleCreateEvent = () => {
      setCreateEvent(prevState => !prevState);
    };

    const getExpiredEvents = async (id) => {
      try {
        const expEvents = await axios.get(`https://event-finder12.onrender.com/events/getExpiredEvents/${id}`);
            setExpiredEvents(expEvents.data);
      } catch(err) {
        console.log(err);
      }
    }

    const handleEditEvent = () => {
      setEditEvent(prevState => !prevState);
      console.log("Edit")
    };

    const getEventDetails = async (id) => {
      try {
          await axios.get(`https://event-finder12.onrender.com/events/getevent/${id}`).then((res)=> {
          setCurrEvent(res.data)
          console.log(res.data)
        })
      } catch(err) {
        console.log(err);
      }
    }

    // const filterActiveEvents = (events) => {
    //   setActiveEvents(events.filter(event => !event.expired));
    // };

    // const getAllEvents = async (id) => {
    //   try {
    //     const resp = await axios.get(
    //       `https://event-finder12.onrender.com/events/getAllEvents/${id}`
    //     );
    //     setEvents(resp.data);
    //     filterActiveEvents(resp.data);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }; 


    const getOrganizerStats = async (id) => {
        try {
          const response = await axios.get(`https://event-finder12.onrender.com/data/organizerData/${id}`)
          setOrgStats(response.data);
        } catch (err) {
          console.log(err);
        }
    }

  
    const contextValue = {
      createEvent,
      handleCreateEvent,
      editEvent, 
      handleEditEvent,
      currEvent, setCurrEvent,getEventDetails,events, setEvents,getExpiredEvents,setExpiredEvents,expiredEvents,getOrganizerStats,setOrgStats,orgStats
    };
  
    return (
      <EventContext.Provider value={contextValue}>
        {children}
      </EventContext.Provider>
    );
}

export default EventProvider